import { render, staticRenderFns } from "./autoPurchase.vue?vue&type=template&id=46990c93&scoped=true&"
import script from "./autoPurchase.vue?vue&type=script&lang=js&"
export * from "./autoPurchase.vue?vue&type=script&lang=js&"
import style0 from "./autoPurchase.vue?vue&type=style&index=0&id=46990c93&lang=less&scoped=true&"
import style1 from "./autoPurchase.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46990c93",
  null
  
)

component.options.__file = "autoPurchase.vue"
export default component.exports